import * as types from '../mutation-types';
import {Form} from 'vform';
import axios from 'axios';

const state = {
    form: new Form({
        name: '',
        permissions: [],
    }),
    all_permissions: [],
    create: false,
    edit: false,
    search: '',
    page: '',
    currentpage: '',
    loading: false,
    roles: [],
    role_id: null,
    error: '',
}

const getters = {
    form: state => state.form,
    create: state => state.create,
    edit: state => state.edit,
    search: state => state.search,
    page: state => state.page,
    currentpage: state => state.currentpage,
    loading: state => state.loading,
    roles: state => state.roles,
    role_id: state => state.role_id,
    all_permissions: state => state.all_permissions,
    error: state => state.error
}

const actions = {
    async fetchRoles({commit}) {
        commit(types.ROLE_LOADING, true);
        let uri = `/api/roles/`;
        await axios.get(uri).then((response) => {
            commit(types.ROLES, response.data);
        }).catch((response) => {
            commit(types.ROLE_ERROR, response.data);
        })
        commit(types.ROLE_LOADING, false);
    },
    async fetchAllPermissions({commit}) {
        let uri = `/api/roles/create`;
        await axios.get(uri).then((response) => {
            commit(types.ALL_PERMISSIONS, response.data);
        })
    }
};

const mutations = {
    [types.ROLE_LOADING](state, boolean) {
        state.loading = boolean;
    },
    [types.ROLES](state, data) {
        state.roles = data;
    },
    [types.ROLE_SEARCH](state, data) {
        state.search = data;
    },
    [types.ROLE_PAGE](state, data) {
        state.page = data;
    },
    [types.ROLE_CURRENTPAGE](state, data) {
        state.currentpage = data;
    },
    [types.ALL_PERMISSIONS](state, data) {
        state.all_permissions = data;
    },
    [types.ROLE_CREATE](state) {
        state.create = !state.create;
    },
    [types.ROLE_EDIT](state, role) {
        state.edit = !state.edit;
        if (state.edit == true) {
            state.form.name = role.name,
                state.form.permissions = role.permissions;
        }
    },
    [types.ROLE_CLEAR](state) {
        state.form.clear();
        state.form.reset();
    },
    [types.ADD_PERMISSION](state, permission) {
        if (!state.form.permissions.includes(permission)) {
            state.form.permissions.push(permission);
        } else {
            let index = state.form.permissions.findIndex((detail) => detail === permission);
            state.form.permissions.splice(index, 1);
        }
    },
    [types.ROLE_ID](state, id) {
        state.role_id = id;
    },
    [types.ROLE_ERROR](state, data) {
        state.error = data;
    }
};

export {
    state,
    getters,
    actions,
    mutations
}
